export default __webpack_public_path__ + "static/media/snake.ef89b902.jpg";